import React, { useEffect, useState, useContext } from "react";
import "./index.scss";
import {
  DatePicker,
  Button,
  message,
  Tooltip,
  Divider,
  Typography,
  Drawer,
  Select,
} from "antd";
import dayjs from "dayjs";
import { useSelector, useDispatch } from "react-redux";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import TeamTree from "./components/teamtree";
import { AuthContext } from "contexts/authContext";
import {
  UserAction,
  TeamAction,
  DesignationAction,
  ShiftAction,
} from "../../redux/store/action";
import UserTree from "./components/usertree";
import { GetTreeNode } from "utils/getTreeNodes";
import { FiSettings } from "react-icons/fi";
import { SETTINGS_EMAILS_ALERTS } from "route/constant";
import { useNavigate } from "react-router-dom";
import CheckboxComponent from "./components/checkbox";
import {
  setDate,
  setEndDate,
  setMonth,
  setStartDate,
  setTeamIds,
  setUserIds as setPinnedUserIds,
  setViewFields as setPinnedViewFields,
  setDatePin,
  setTeamUserPin,
  setTeamParentIds,
  setWeekStartDate,
  setWeekEndDate,
  setFilters,
} from "redux/store/filters/action";
import { BsPinAngle, BsPinAngleFill } from "react-icons/bs";
import isBetween from "dayjs/plugin/isBetween"; // Import the isBetween plugin
import {
  disabledDateWeek,
  disabledDateWeekTeams,
  getWeekRangePresets,
  permissionsMap,
} from "constants/constants";
import updateLocale from "dayjs/plugin/updateLocale";
import { getCustomFieldKey } from "utils/commonUtils";
import ColumnsSwitch from "./components/ColumnsSwitch";
import { BiColumns, BiFilter } from "react-icons/bi";
import {
  existingUserFields,
  filterUsers,
  validateFilterAndExtract,
} from "utils/filterUtils";
import FiltersDrawer from "./components/FiltersDrawer";
import { IoMdClose } from "react-icons/io";
import { MdFilterAltOff } from "react-icons/md";

dayjs.extend(updateLocale);
dayjs.updateLocale("en", {
  weekStart: 1,
});

// dayjs.extend(isoWeek);
dayjs.extend(customParseFormat);
dayjs.extend(isBetween); // Extend dayjs with isBetween plugin
const { RangePicker, MonthPicker } = DatePicker;
const { Text } = Typography;

const rangePresets = [
  {
    label: "Today",
    value: [dayjs().startOf("day"), dayjs().endOf("day")],
  },
  {
    label: "Yesterday",
    value: [
      dayjs().subtract(1, "day").startOf("day"),
      dayjs().subtract(1, "day").endOf("day"),
    ],
  },
  {
    label: "Last 7 Days",
    value: [dayjs().add(-6, "d"), dayjs()],
  },
  {
    label: "Last 14 Days",
    value: [dayjs().add(-13, "d"), dayjs()],
  },
  {
    label: "Last 31 Days",
    value: [dayjs().add(-30, "d"), dayjs()],
  },
];

const rangePresetsCrossDay = [
  {
    label: "Yesterday",
    value: [
      dayjs().subtract(1, "day").startOf("day"),
      dayjs().subtract(1, "day").endOf("day"),
    ],
  },
  {
    label: "Last 7 Days",
    value: [
      dayjs().subtract(7, "day").startOf("day"),
      dayjs().subtract(1, "day").endOf("day"),
    ],
  },
  {
    label: "Last 14 Days",
    value: [
      dayjs().subtract(14, "day").startOf("day"),
      dayjs().subtract(1, "day").endOf("day"),
    ],
  },
  {
    label: "Last 31 Days",
    value: [
      dayjs().subtract(31, "day").startOf("day"),
      dayjs().subtract(1, "day").endOf("day"),
    ],
  },
];

const Filter = (props) => {
  const {
    modelName,
    teamshow,
    usershow,
    monthshow,
    rangeshow,
    weekshow,
    btnDownload,
    ExportDownload,
    btnDownloadPdf,
    DownloadPdf,
    btnReload,
    date,
    rangeDisabledDate,
    month,
    startDate,
    endDate,
    weekStartDate,
    weekEndDate,
    monthpikershow = false,
    loadingbtn = false,
    loadingBtnPdf = false,
    btnAlertSettings,
    singleSelect,
    selectedUserIds,
    children,
    isAppUrl,
    checkboxOptions,
    checkboxDefaultValue,
    appUrlOnChaneType,
    prefixShiftBased,
    prefixComponents,
    prefixTimePickerComponents,
    prefixTimeCalComponents,
    suffixTimesheetComponents,
    teamFilterPrefixComponents,
    singleSelectReload,
    futureDateDisable = true,
    reportType,
    disableDateWeek = false,
    showFieldsSelection = false,
    teamSelectWidth = "140px",
    userSelectWidth = "140px",
    show_parent_teams_only_filter = false,
    screenRecordingBulkDownloadDays,
    segment,
    updateAllFilters = () => {
      return true;
    },
  } = props || {};

  const {
    team_list_success,
    team_list_data,
    team_list_failed,
    team_list_message,
    team_map_data,
  } = useSelector((state) => state.team);
  const { KState, checkRequiredPermissions, getDefaultHeader } =
    useContext(AuthContext);
  const [teamTreeData, setTeamTreeData] = useState([]);
  const {
    medetails_data,
    user_list_processing,
    user_list_success,
    user_list_data,
    user_list_failed,
    team_wise_user_list_message,
    team_list_process,
  } = useSelector((state) => state.users);

  const { workplace_setting_data } = useSelector(
    (state) => state.workplaceSettings
  );

  const { designation_list_success, designation_list_processing } = useSelector(
    (state) => state.designation
  );

  const { shifts_list_success, shifts_list_loading } = useSelector(
    (state) => state.shift
  );

  const {
    teamUserPin,
    datePin,
    teamUserPinDate,
    datePinDate,
    date: pinnedDate,
    startDate: pinnedStartDate,
    endDate: pinnedEndDate,
    month: pinnedMonth,
    userIds: pinnedUserIds,
    teamIds: pinnedTeamIds,
    viewFields: pinnedViewFields,
    teamParentIds: pinnedTeamParentIds,
    weekStartDate: pinnedWeekStartDate,
    weekEndDate: pinnedWeekEndDate,
    filters,
  } = useSelector((state) => state.filters);

  const intialViewFields =
    workplace_setting_data?.ui?.extras?.defaultColumns?.reports || [];

  const [userNodes, setuserNodes] = useState([]);
  const [isReload, setisReload] = useState(false);
  const [initialMonth, setInitialMonth] = useState(dayjs());
  const [initialDate, setInitialDate] = useState(dayjs());
  const [sDate, setsDate] = useState(dayjs().subtract(6, "day"));
  const [eDate, seteDate] = useState(dayjs());
  const [isActive, setActive] = useState(false);
  const [selectedTeamParentIds, setSelectedTeamParentIds] = useState([]);
  const [selectedTeamIds, setSelectedTeamIds] = useState([]);
  const [allTeamSelect, setAllTeamSelect] = useState(false);
  const [parentTeamsOnly, setParentTeamsOnly] = useState(false);
  const [viewFields, setViewFields] = useState(intialViewFields);
  const [columnsDrawerOpen, setColumnsDrawerOpen] = useState(null);
  const [filtersDrawerOpen, setFiltersDrawerOpen] = useState(null);

  // Check if screen recording bulk download is enabled
  const isScreenRecordingBulkDownload =
    segment === "SCREEN_RECORDING" &&
    typeof screenRecordingBulkDownloadDays === "number" &&
    screenRecordingBulkDownloadDays > 0;

  useEffect(() => {
    if (isScreenRecordingBulkDownload && (!startDate || !endDate)) {
      const defaultStartDate = dayjs().subtract(
        screenRecordingBulkDownloadDays - 1,
        "d"
      );
      const defaultEndDate = dayjs();

      updateAllFilters({
        teamUserPin,
        datePin,
        filterStartDate: defaultStartDate,
        filterEndDate: defaultEndDate,
        dateRangeChange: true,
      });
    }
  }, [isScreenRecordingBulkDownload, screenRecordingBulkDownloadDays]);

  const getFilteredUsers = (selectedTeam = selectedTeamIds) => {
    return filterUsers(user_list_data, team_map_data || [], filters).filter(
      (user) =>
        selectedTeam.includes(user.attached_group_id) ||
        selectedTeam.length === 0
    );
  };

  const handleUserFilterClear = () => {
    dispatch(setFilters([[null, null, null, null]]));
    getUserTreeNode(
      user_list_data.filter(
        (user) =>
          selectedTeamIds.includes(user.attached_group_id) ||
          selectedTeamIds.length === 0
      )
    );
  };

  const onFilterDrawerClose = () => {
    setFiltersDrawerOpen(false);

    const filteredUsers = getFilteredUsers();
    getUserTreeNode(filteredUsers);
    console.log(filters);
    if (
      filters.filter((filter) => validateFilterAndExtract(filter).valid)
        .length > 0
    ) {
      selectUsers(filteredUsers.map((user) => user.identity.id));
    } else {
      selectUsers([]);
    }
  };

  const onViewFieldsChange = (finalViewFields) => {
    setViewFields(finalViewFields);

    updateAllFilters({
      teamUserPin,
      datePin,
      filterViewFields: finalViewFields,
      viewFieldsChange: true,
    });
    highlightPin("team-user-pin");
    if (teamUserPin) {
      dispatch(setPinnedViewFields(finalViewFields));
    }
  };

  const [selectedLabel, setSelectedLabel] = useState(
    `Current Week: ${dayjs(weekStartDate).format("D MMM")} - ${dayjs(
      weekEndDate
    ).format("D MMM")}`
  );

  const rangActive = false;
  const dispatch = useDispatch();

  const GetTeamList = () => {
    if (KState && KState.keycloak) {
      const data = {
        clientId: KState.keycloak.clientId,
        token: KState.keycloak.token,
      };
      dispatch(TeamAction.TeamListProcess(data));
    }
  };

  const GetUserList = () => {
    if (KState && KState.keycloak) {
      const data = {
        headers: getDefaultHeader(),
        isOwner: checkRequiredPermissions([permissionsMap.TENANT_OWNER]),
      };

      dispatch(UserAction.UserListProcess(data));
    }
  };

  const getDesignationsList = () => {
    if (KState && KState.keycloak) {
      const data = {
        clientId: KState.keycloak.clientId,
        token: KState.keycloak.token,
      };
      dispatch(DesignationAction.DesignationListProcess(data));
    }
  };

  const getShiftsList = () => {
    if (KState && KState.keycloak) {
      const data = {
        clientId: KState.keycloak.clientId,
        token: KState.keycloak.token,
      };

      dispatch(ShiftAction.ShiftsListProcess(data));
    }
  };

  // team data
  useEffect(() => {
    if (!user_list_success && !user_list_processing) {
      dispatch(UserAction.TeamWiseUserListInitial());
      GetUserList();
    }
    if (!team_list_success && !team_list_process) {
      GetTeamList();
    }
    if (!designation_list_success && !designation_list_processing) {
      getDesignationsList();
    }
    if (!shifts_list_success && !shifts_list_loading) {
      getShiftsList();
    }
  }, []);

  useEffect(() => {
    if (team_list_success) {
      setisReload(false);
      if ((team_list_data || []).length > 0) {
        const groupID = medetails_data?.attached_group_id;

        const treeGroupData = checkRequiredPermissions([
          permissionsMap.TENANT_OWNER,
        ])
          ? GetTreeNode(team_list_data)
          : [
              {
                title: team_map_data[medetails_data?.attached_group_id]?.name,
                value: groupID,
                children: GetTreeNode(team_list_data, groupID),
              },
            ];

        setTeamTreeData(treeGroupData);
      }
    } else if (team_list_failed) {
      setisReload(false);
      // message.error(team_list_message?.message);
    }
  }, [team_list_success, team_list_data, team_list_failed, team_list_message]);

  const getUserTreeNode = (userList) => {
    const ulist = [];
    let id = "";
    let fullname = "";

    userList.forEach((item) => {
      id = item?.identity?.id;
      fullname = item?.identity?.first_name + " " + item?.identity?.last_name;
      ulist.push({
        title: fullname,
        children: null,
        value: id,
      });
    });

    setuserNodes(ulist);

    setisReload(false);
  };

  useEffect(() => {
    if (user_list_success === true) {
      if ((user_list_data || []).length > 0) {
        getUserTreeNode(
          filterUsers(user_list_data, team_map_data || [], filters)
        );
      } else if (user_list_failed === true) {
        // message.error(team_wise_user_list_message?.message);

        setuserNodes([]);

        setisReload(false);
      }
    }
  }, [
    user_list_success,
    user_list_failed,
    team_wise_user_list_message,
    user_list_failed,
  ]);

  const selectUsers = (val) => {
    // console.log("selectedUsers", val);
    // filterDataPass && filterDataPass(val);

    if (
      val.length === 0 &&
      filters.filter((filter) => validateFilterAndExtract(filter).valid)
        .length > 0 &&
      getFilteredUsers().length > 0
    ) {
      handleUserFilterClear();
    }
    updateAllFilters({
      teamUserPin,
      datePin,
      filterUserIds: val,
      userChange: true,
    });
    highlightPin("team-user-pin");
    if (teamUserPin && !singleSelect) {
      dispatch(setPinnedUserIds(val));
    }
  };

  // Helper function to get all child team IDs from a parent team ID
  const getAllChildTeamIds = (parentId, teamList = team_list_data) => {
    const childIds = [];
    const findChildren = (parentId) => {
      teamList.forEach((team) => {
        if (team.parent?.id === parentId) {
          childIds.push(team.id);
          findChildren(team.id); // Recursively find grandchildren
        }
      });
    };
    findChildren(parentId);
    return childIds;
  };

  const selectteam = (selectedTeam) => {
    // console.log("selectedTeam", selectedTeam);
    // selectTeam(selectedTeam);
    let finalTeamIds = selectedTeam;

    // If parentTeamsOnly is true, include all child teams but only show parent teams
    if (parentTeamsOnly && selectedTeam && selectedTeam.length > 0) {
      const allTeamIds = new Set(selectedTeam);
      selectedTeam.forEach((teamId) => {
        const childIds = getAllChildTeamIds(teamId);
        childIds.forEach((childId) => allTeamIds.add(childId));
      });
      finalTeamIds = Array.from(allTeamIds);
    }
    let value = [];
    if (
      filters.filter((filter) => validateFilterAndExtract(filter).valid)
        .length > 0
    ) {
      value = getFilteredUsers(finalTeamIds).map((user) => user.identity.id);
    }
    setSelectedTeamIds(finalTeamIds);
    updateAllFilters({
      teamUserPin,
      datePin,
      filterTeamIds: finalTeamIds,
      filterUserIds: value,
      teamChange: true,
      parent_teams_only: parentTeamsOnly,
    });

    highlightPin("team-user-pin");
    if (teamUserPin) {
      dispatch(setTeamIds(finalTeamIds));

      dispatch(setPinnedUserIds([]));
    }
    if ((finalTeamIds || []).length > 0) {
      getUserTreeNode(
        filterUsers(user_list_data, team_map_data || [], filters).filter(
          (user) => finalTeamIds.includes(user.attached_group_id)
        )
      );
    } else if ((finalTeamIds || []).length === 0) {
      getUserTreeNode(
        filterUsers(user_list_data, team_map_data || [], filters)
      );
    }
  };

  const selectTeamParent = (selectedTeamParent) => {
    // console.log("selectedTeamParent", selectedTeamParent);
    setSelectedTeamParentIds(selectedTeamParent);
    if (teamUserPin) {
      dispatch(setTeamParentIds(selectedTeamParent));
    }
    // When parentTeamsOnly is true, call selectteam with parent IDs to include children
    if (parentTeamsOnly) {
      selectteam(selectedTeamParent);
    }
  };

  const onDateChange = (date) => {
    // console.log("date", date);
    setActive(!isActive);
    // onSelectDate(date || dayjs(), dateStrings || dayjs().toISOString());
    // setInitialDate(date || dayjs());

    updateAllFilters({
      teamUserPin,
      datePin,
      filterDate: date,
      dateChange: true,
    });
    highlightPin("date-pin");
    if (datePin) {
      dispatch(setDate(date));
    }
  };

  const onDateRangeChange = (dates, dateStrings) => {
    if (!dates || !dates[0] || !dates[1]) {
      return;
    }

    const startDate = dayjs(_.nth(dateStrings, 0));
    let endDate = dayjs(_.nth(dateStrings, 1));

    if (isScreenRecordingBulkDownload) {
      const Daydiff = dayjs(endDate).diff(dayjs(startDate), "days") + 1;
      if (Daydiff > screenRecordingBulkDownloadDays) {
        message.warning(
          `Max select date range ${screenRecordingBulkDownloadDays} days for Screen Recording`
        );
        endDate = dayjs(startDate).add(
          screenRecordingBulkDownloadDays - 1,
          "d"
        );
      }
    } else {
      const Daydiff = dayjs(endDate).diff(dayjs(startDate), "days");
      if (Daydiff > 31) {
        message.warning("Max select date range 31 days");
        endDate = dayjs(startDate).add(30, "d");
      }
    }

    updateAllFilters({
      teamUserPin,
      datePin,
      filterStartDate: startDate,
      filterEndDate: endDate,
      dateRangeChange: true,
    });
    highlightPin("date-pin");
    if (datePin) {
      dispatch(setStartDate(startDate));
      dispatch(setEndDate(endDate));
    }
  };

  const onRefresh = () => {
    console.log("refresh");

    updateAllFilters({
      teamUserPin,
      datePin,
      refresh: true,
    });
  };

  const onReload = () => {
    console.log("reload");
    setisReload(true);

    // setsDate(sdate);
    // seteDate(edate);
    // setInitialDate(dayjs());
    // setSelectedTeamIds([]);
    // ClickReload(true);
    dispatch(setFilters([[null, null, null, null]]));

    updateAllFilters({
      teamUserPin,
      datePin,
      filterDate: dayjs(),
      filterStartDate:
        reportType === "crossday"
          ? dayjs().subtract(7, "d")
          : dayjs().subtract(6, "d"),
      filterEndDate:
        reportType === "crossday" ? dayjs().subtract(1, "d") : dayjs(),
      filterMonthStart: dayjs().startOf("month"),
      filterMonthEnd: dayjs().endOf("month"),
      filterUserIds: [],
      filterTeamIds: [],
      reload: true,
      filterWeekStartDate: dayjs().startOf("week"),
      filterWeekEndDate: dayjs().endOf("week"),
    });

    setSelectedTeamIds([]);
    setSelectedTeamParentIds([]);

    if (datePin) {
      dispatch(setDate(dayjs()));
      dispatch(setStartDate(dayjs().subtract(6, "d")));
      dispatch(setEndDate(dayjs()));
      dispatch(setMonth(dayjs()));
      dispatch(setWeekStartDate(dayjs().startOf("week")));
      dispatch(setWeekEndDate(dayjs().endOf("week")));
    }
    if (teamUserPin) {
      dispatch(setTeamIds([]));
      dispatch(setTeamParentIds([]));
      dispatch(setPinnedUserIds([]));
      dispatch(setPinnedViewFields(intialViewFields));
    }
  };
  function disableCurrent(current) {
    return current && current >= dayjs().startOf("day");
  }

  function disabledDate(current) {
    const weekStart = dayjs().subtract(2, "year");
    const weekEnd = dayjs().endOf("day");
    return !(weekStart.isBefore(current) && weekEnd.isAfter(current));
  }

  function disabledDateForScreenRecording(current) {
    const weekStart = dayjs().subtract(2, "year");
    const weekEnd = dayjs().endOf("day");
    return !(weekStart.isBefore(current) && weekEnd.isAfter(current));
  }

  const onMonthChange = (monthDate) => {
    // console.log("monthDate", monthDate);
    // const sdate = dayjs(monthDate || Date.now()).startOf("month");
    // const edate = dayjs(monthDate || Date.now()).endOf("month");
    // OnSelctMonth(sdate, edate);

    updateAllFilters({
      teamUserPin,
      datePin,
      filterMonthStart: dayjs(monthDate || Date.now()).startOf("month"),
      filterMonthEnd: dayjs(monthDate || Date.now()).endOf("month"),
      monthChange: true,
    });
    highlightPin("date-pin");

    if (datePin) {
      dispatch(setMonth(monthDate));
    }
  };

  const navigate = useNavigate();
  const handleAction = () => {
    navigate(SETTINGS_EMAILS_ALERTS, { state: { settingKey: "alertRules" } });
  };

  const appUrlOnChange = (value) => {
    appUrlOnChaneType(value);
  };

  useEffect(() => {
    console.log("reset");

    let datePinStale = false;
    let teamUserPinStale = false;

    if (datePin && new Date(datePinDate).getDay() !== new Date().getDay()) {
      onDatePin();
      datePinStale = true;
    }

    if (
      teamUserPin &&
      new Date(teamUserPinDate).getDay() !== new Date().getDay()
    ) {
      onTeamUserPin();
      teamUserPinStale = true;
    }

    if (teamUserPin && !teamUserPinStale) {
      setSelectedTeamIds(pinnedTeamIds);
      setSelectedTeamParentIds(pinnedTeamParentIds);
    } else {
      setSelectedTeamIds([]);
      setSelectedTeamParentIds([]);
      dispatch(setFilters([[null, null, null, null]]));
    }

    updateAllFilters({
      initialized: true,
      teamUserPin,
      datePin,
      filterDate:
        datePin && pinnedDate && !datePinStale
          ? dayjs(pinnedDate)
          : date || dayjs(),
      filterStartDate:
        datePin && pinnedStartDate && !datePinStale
          ? dayjs(pinnedStartDate)
          : startDate || dayjs().subtract(6, "d"),
      filterEndDate:
        datePin && pinnedEndDate && !datePinStale
          ? dayjs(pinnedEndDate)
          : endDate || dayjs(),

      filterWeekStartDate:
        datePin && pinnedWeekStartDate && !datePinStale
          ? dayjs(pinnedWeekStartDate)
          : weekStartDate || dayjs().startOf("week"),
      filterWeekEndDate:
        datePin && pinnedWeekEndDate && !datePinStale
          ? dayjs(pinnedWeekEndDate)
          : weekEndDate || dayjs().endOf("week"),
      filterMonthStart:
        datePin && pinnedMonth && !datePinStale
          ? dayjs(pinnedMonth).startOf("month")
          : dayjs(month || dayjs()).startOf("month"),
      filterMonthEnd:
        datePin && pinnedMonth && !datePinStale
          ? dayjs(pinnedMonth).endOf("month")
          : dayjs(month || dayjs()).endOf("month"),
      filterUserIds:
        teamUserPin && pinnedUserIds && !teamUserPinStale
          ? pinnedUserIds
          : selectedUserIds || [],
      filterTeamIds:
        teamUserPin && pinnedTeamIds && !teamUserPinStale ? pinnedTeamIds : [],
      filterViewFields:
        teamUserPin && pinnedViewFields && !teamUserPinStale
          ? pinnedViewFields
          : viewFields,
    });

    if (
      teamUserPin &&
      !teamUserPinStale &&
      pinnedTeamIds &&
      teamshow &&
      usershow
    ) {
      // selectTeam(pinnedTeamIds);
      if ((pinnedTeamIds || []).length > 0) {
        getUserTreeNode(
          filterUsers(user_list_data, team_map_data || [], filters).filter(
            (user) => pinnedTeamIds.includes(user.attached_group_id)
          )
        );
      } else {
        getUserTreeNode(
          filterUsers(user_list_data, team_map_data || [], filters)
        );
      }
    }
  }, [
    monthshow,
    rangeshow,
    weekshow,
    monthpikershow,
    teamshow,
    usershow,
    user_list_success,
  ]);

  const onDatePin = () => {
    if (datePin) {
      dispatch(setDatePin(false));
      dispatch(setDate(null));
      dispatch(setStartDate(null));
      dispatch(setEndDate(null));
      dispatch(setMonth(null));
      dispatch(setWeekStartDate(null));
      dispatch(setWeekEndDate(null));
    } else {
      dispatch(setDatePin(true));
      dispatch(setDate(dayjs(date || initialDate)));
      dispatch(setStartDate(dayjs(startDate || sDate)));
      dispatch(setEndDate(dayjs(endDate || eDate)));
      dispatch(setMonth(dayjs(month || initialMonth)));
      dispatch(setWeekStartDate(dayjs(weekStartDate)));
      dispatch(setWeekEndDate(dayjs(weekEndDate)));
    }
  };

  const onTeamUserPin = () => {
    if (teamUserPin) {
      dispatch(setTeamUserPin(false));

      dispatch(setPinnedUserIds([]));
      dispatch(setTeamIds([]));
      dispatch(setTeamParentIds([]));
      dispatch(setPinnedViewFields(intialViewFields));
    } else {
      dispatch(setTeamUserPin(true));

      dispatch(setTeamIds(selectedTeamIds || []));
      dispatch(setTeamParentIds(selectedTeamParentIds || []));
      dispatch(setPinnedUserIds(selectedUserIds || []));
      dispatch(setPinnedViewFields(viewFields || intialViewFields));
    }
  };

  const highlightPin = (pinId) => {
    if (pinId) {
      document.getElementById(pinId)?.classList.add("highlight");
      setTimeout(() => {
        document.getElementById(pinId)?.classList.remove("highlight");
      }, 1000);
    }
  };

  const disableMonth = (current) => {
    if (modelName !== "leave") {
      // Disable current and future months
      // return current && current >= dayjs().startOf("month");
      return current && current >= dayjs().startOf("month");
    }

    // Enable all months if modelName is "leave"
    return false;
  };

  const handleWeekChange = (date) => {
    console.log("week-change");
    const rangePresets = getWeekRangePresets();
    console.log(rangePresets);
    const startOfSelectedWeek = date.startOf("week");
    const endOfSelectedWeek = date.endOf("week");
    console.log("startOfSelectedWeek", startOfSelectedWeek);
    console.log("endOfSelectedWeek", endOfSelectedWeek);
    if (date) {
      updateAllFilters({
        teamUserPin,
        filterWeekStartDate: startOfSelectedWeek,
        filterWeekEndDate: endOfSelectedWeek,
        datePin,
        weekChange: true,
      });
    }

    highlightPin("date-pin");
    if (datePin) {
      dispatch(setWeekStartDate(startOfSelectedWeek));
      dispatch(setWeekEndDate(endOfSelectedWeek));
    }
  };

  useEffect(() => {
    if (weekStartDate && weekEndDate) {
      const rangePresets = getWeekRangePresets();

      const matchingPreset = rangePresets.find(
        (preset) =>
          preset.value[0].isSame(weekStartDate, "day") &&
          preset.value[1].isSame(weekEndDate, "day")
      );
      const presetLabel = matchingPreset ? matchingPreset.label : "";
      const selectedLabel = presetLabel
        ? `${presetLabel}: ${weekStartDate.format(
            "D MMM"
          )} - ${weekEndDate.format("D MMM")}`
        : `${weekStartDate.format("D MMM")} - ${weekEndDate.format("D MMM")}`;
      setSelectedLabel(selectedLabel);
    }
  }, [weekStartDate, weekEndDate]);

  const customWeekFormat = (value) => {
    const rangePresets = getWeekRangePresets();
    const startOfSelectedWeek = value.startOf("week");
    const endOfSelectedWeek = value.endOf("week");
    const matchingPreset = rangePresets.find(
      (preset) =>
        preset.value[0].isSame(startOfSelectedWeek, "day") &&
        preset.value[1].isSame(endOfSelectedWeek, "day")
    );
    const presetLabel = matchingPreset ? matchingPreset.label : "Selected Week";
    return `${presetLabel}: ${startOfSelectedWeek.format(
      "D MMM"
    )} - ${endOfSelectedWeek.format("D MMM")}`;
  };

  const getScreenRecordingRangePresets = () => {
    if (!isScreenRecordingBulkDownload) return rangePresets;

    const presets = [];
    const maxDays = screenRecordingBulkDownloadDays;

    if (maxDays >= 1) {
      presets.push({
        label: "Today",
        value: [dayjs().startOf("day"), dayjs().endOf("day")],
      });
    }

    if (maxDays >= 2) {
      presets.push({
        label: "Yesterday",
        value: [
          dayjs().subtract(1, "day").startOf("day"),
          dayjs().subtract(1, "day").endOf("day"),
        ],
      });
    }

    if (maxDays >= 7) {
      presets.push({
        label: "Last 7 Days",
        value: [dayjs().subtract(6, "d"), dayjs()],
      });
    }

    if (maxDays >= 14) {
      presets.push({
        label: "Last 14 Days",
        value: [dayjs().subtract(13, "d"), dayjs()],
      });
    }

    if (maxDays >= 31) {
      presets.push({
        label: "Last 31 Days",
        value: [dayjs().subtract(30, "d"), dayjs()],
      });
    }

    if (maxDays > 1 && ![7, 14, 31].includes(maxDays)) {
      presets.push({
        label: `Last ${maxDays} Days`,
        value: [dayjs().subtract(maxDays - 1, "d"), dayjs()],
      });
    }

    return presets;
  };

  return (
    <>
      <Drawer
        size="large"
        destroyOnClose
        width={400}
        open={columnsDrawerOpen && showFieldsSelection}
        title={"Fields"}
        onClose={() => {
          setColumnsDrawerOpen(false);
        }}
        className="filter-drawer"
      >
        <ColumnsSwitch
          viewFields={viewFields}
          onViewFieldsChange={onViewFieldsChange}
          allUserFields={(
            workplace_setting_data?.workplace?.custom_fields || []
          ).reduce(
            (acc, field) => ({
              ...acc,
              [getCustomFieldKey(field)]: {
                label: field.label,
                key: getCustomFieldKey(field),
                order: 9,
              },
            }),
            existingUserFields
          )}
        />
      </Drawer>

      <FiltersDrawer
        onClose={onFilterDrawerClose}
        open={filtersDrawerOpen && usershow}
      />

      <div className="filter">
        <div className="filter_data ">
          <div className="f_start">
            {teamFilterPrefixComponents}
            {show_parent_teams_only_filter && teamshow ? (
              <Select
                value={parentTeamsOnly ? "parent_only" : "all"}
                onChange={(value) => {
                  const isParentOnly = value === "parent_only";
                  setParentTeamsOnly(isParentOnly);
                  // Reset team selection when switching modes
                  setSelectedTeamIds([]);
                  setSelectedTeamParentIds([]);
                  selectteam([]);
                  updateAllFilters({
                    teamUserPin,
                    datePin,
                    parent_teams_only: isParentOnly,
                    filterTeamIds: [],
                    teamChange: true,
                    parentTeamsOnlyChange: true,
                  });
                  if (teamUserPin) {
                    dispatch(setTeamIds([]));
                  }
                }}
                style={{ minWidth: "180px", marginRight: "8px" }}
                placeholder="Select team type"
              >
                <Select.Option value="all">All Individual Teams</Select.Option>
                <Select.Option value="parent_only">
                  Parent Teams Only
                </Select.Option>
              </Select>
            ) : null}
            {teamshow ? (
              (teamTreeData || []).length > 0 ? (
                <TeamTree
                  datateam={teamTreeData}
                  selectTeam={(Team) => selectteam(Team)}
                  isReload={isReload && isReload}
                  initialTeamIds={
                    teamUserPin && pinnedTeamParentIds
                      ? pinnedTeamParentIds
                      : []
                  }
                  selectedTeamIds={
                    parentTeamsOnly ? selectedTeamParentIds : selectedTeamIds
                  }
                  selectTeamParent={selectTeamParent}
                  allTeamSelect={allTeamSelect}
                  setAllTeamSelect={setAllTeamSelect}
                  teamSelectWidth={teamSelectWidth}
                />
              ) : null
            ) : null}

            {usershow && (
              <>
                <UserTree
                  filterDataPass={(Users) => selectUsers(Users)}
                  userNodes={userNodes}
                  isReload={
                    singleSelect && !singleSelectReload ? false : isReload
                  }
                  singleSelect={singleSelect}
                  selectedUserIds={selectedUserIds}
                  singleSelectReload={singleSelectReload}
                  userSelectWidth={userSelectWidth}
                />
                <Tooltip title="Filters">
                  <Button
                    onClick={() => {
                      setFiltersDrawerOpen(true);
                    }}
                    className="ml-2 flex gap-2 px-2 filter-drawer-button"
                  >
                    <BiFilter className="text-xl" />
                    {/* Filters{" "} */}
                    {filters.filter(
                      (filter) => validateFilterAndExtract(filter).valid
                    ).length || null}
                    {!!filters.filter(
                      (filter) => validateFilterAndExtract(filter).valid
                    ).length && (
                      <Tooltip title="Clear User Filters">
                        <div
                          className="filter-drawer-button-clear absolute right-0 h-[30px] w-[30px] rounded  text-gray-500 bg-gray-200 border-gray-300 hover:text-gray-700 hover:bg-gray-300 hover:border-gray-500 cursor-pointer flex items-center justify-center text-xl"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleUserFilterClear();
                          }}
                        >
                          <IoMdClose className="text-lg" />
                        </div>
                      </Tooltip>
                    )}
                  </Button>
                </Tooltip>
              </>
            )}

            {showFieldsSelection && (
              <Tooltip title="Show/Hide Columns">
                <Button
                  onClick={() => {
                    setColumnsDrawerOpen(true);
                  }}
                  className="ml-2 flex gap-2  px-2"
                >
                  <BiColumns />
                  {/* Columns */}
                </Button>
              </Tooltip>
            )}

            {((usershow && !singleSelect) || teamshow) && (
              <div className="ml-1">
                <Tooltip
                  title={
                    teamUserPin
                      ? "Unpin Team & User filters"
                      : "Pin Team & User filters"
                  }
                >
                  {teamUserPin ? (
                    <BsPinAngleFill
                      className="w-5 h-5  p-1 cursor-pointer rounded hover:bg-gray-200 hover:text-blue-500"
                      onClick={onTeamUserPin}
                    />
                  ) : (
                    <BsPinAngle
                      id="team-user-pin"
                      className="w-5 h-5 p-1 cursor-pointer rounded hover:bg-gray-200 hover:text-blue-500 transition duration-500 ease-in-out"
                      onClick={onTeamUserPin}
                    />
                  )}
                </Tooltip>
              </div>
            )}
            {isAppUrl && (
              <div className="pl-5">
                <CheckboxComponent
                  options={checkboxOptions}
                  defaultValue={checkboxDefaultValue}
                  onChange={appUrlOnChange}
                />
              </div>
            )}
            <div className="ml-3" />
            {prefixComponents}
            {prefixShiftBased}
          </div>

          <div className="f_end gap-3">
            {children}
            {monthshow && !isScreenRecordingBulkDownload ? (
              <DatePicker
                inputReadOnly
                defaultValue={datePin && pinnedDate ? pinnedDate : initialDate}
                value={date}
                disabledDate={disabledDate}
                format="YYYY-MM-DD "
                style={{ width: 180 }}
                className={isActive ? "cal_active" : null}
                onChange={onDateChange}
                clearIcon={null}
              />
            ) : null}

            {monthshow && isScreenRecordingBulkDownload ? (
              <RangePicker
                style={{ width: 255 }}
                defaultValue={
                  datePin && pinnedEndDate && pinnedStartDate
                    ? [pinnedStartDate, pinnedEndDate]
                    : [
                        dayjs().subtract(
                          screenRecordingBulkDownloadDays - 1,
                          "d"
                        ),
                        dayjs(),
                      ]
                }
                value={startDate && endDate ? [startDate, endDate] : null}
                presets={getScreenRecordingRangePresets()}
                onChange={onDateRangeChange}
                className={rangActive ? "rang_active " : null}
                disabledDate={disabledDateForScreenRecording}
                dateRender={(current) => {
                  const date = current.date();
                  return date <= 31 ? (
                    <div className="ant-picker-cell-inner">{date}</div>
                  ) : null;
                }}
                clearIcon={null}
              />
            ) : null}

            {prefixTimePickerComponents}

            {rangeshow ? (
              <RangePicker
                style={{ width: 255 }} // not too small                inputReadOnly
                defaultValue={
                  datePin && pinnedEndDate && pinnedStartDate
                    ? [pinnedStartDate, pinnedEndDate]
                    : [sDate, eDate]
                }
                value={[startDate, endDate]}
                presets={
                  reportType === "crossday"
                    ? rangePresetsCrossDay
                    : rangePresets
                }
                onChange={onDateRangeChange}
                className={rangActive ? "rang_active " : null}
                disabledDate={
                  rangeDisabledDate
                    ? rangeDisabledDate
                    : reportType === "crossday"
                    ? disableCurrent
                    : disabledDate
                }
                dateRender={(current) => {
                  const date = current.date();
                  return date <= 31 ? (
                    <div className="ant-picker-cell-inner">{date}</div>
                  ) : null;
                }}
                clearIcon={null}
              />
            ) : null}
            {weekshow ? (
              <>
                <DatePicker
                  allowClear={false}
                  className=" w-[268px]"
                  picker="week"
                  defaultValue={
                    datePin && pinnedWeekEndDate && pinnedWeekStartDate
                      ? [pinnedWeekStartDate, pinnedWeekEndDate]
                      : [weekStartDate, weekEndDate]
                  }
                  value={weekStartDate} // Showing the start of the week in the picker
                  onChange={handleWeekChange}
                  format={customWeekFormat}
                  presets={getWeekRangePresets().map((preset) => ({
                    label: preset.label,
                    value: preset.value[0], // Preset will pick the start of the week
                  }))}
                  renderExtraFooter={() => (
                    <div>
                      {selectedLabel ? (
                        <Text>Selected: {selectedLabel}</Text>
                      ) : (
                        ""
                      )}
                    </div>
                  )}
                  disabledDate={
                    disableDateWeek ? disabledDateWeek : disabledDateWeekTeams
                  }
                />
              </>
            ) : null}

            {monthpikershow ? (
              <MonthPicker
                inputReadOnly
                defaultValue={
                  datePin && pinnedMonth ? pinnedMonth : initialMonth
                }
                value={month}
                disabledDate={futureDateDisable ? disabledDate : disableMonth}
                format="MMM"
                style={{ width: 180 }}
                className={isActive ? "cal_active" : null}
                onChange={onMonthChange}
                clearIcon={null}
              />
            ) : null}
            {(monthpikershow || monthshow || rangeshow || weekshow) && (
              <div className="-ml-2 -mr-1">
                <Tooltip title={datePin ? "Unpin Date" : "Pin Date"}>
                  {datePin ? (
                    <BsPinAngleFill
                      className="w-5 h-5  p-1 cursor-pointer rounded hover:bg-gray-200 hover:text-blue-500"
                      onClick={onDatePin}
                    />
                  ) : (
                    <BsPinAngle
                      id="date-pin"
                      className="w-5 h-5 p-1 cursor-pointer rounded hover:bg-gray-200 hover:text-blue-500 transition duration-500 ease-in-out"
                      onClick={onDatePin}
                    />
                  )}
                </Tooltip>
              </div>
            )}
            {suffixTimesheetComponents}
            {/* {sortby ? <SortBy /> : null} */}
            {btnDownload ? (
              <div>
                {/* <Tooltip
                  title={
                    reportType === "raw" && selectedUserIds?.length !== 1
                      ? "You have to select any single user to download the Log Report."
                      : "Download"
                  }
                > */}
                <Button
                  loading={loadingbtn}
                  icon={<DownloadOutlined />}
                  onClick={ExportDownload}
                  // disabled={
                  //   reportType === "raw" && selectedUserIds?.length !== 1
                  // }
                />
                {/* </Tooltip> */}
              </div>
            ) : null}
            {btnDownloadPdf ? (
              <div>
                <Tooltip title="Download PDF">
                  <Button
                    loading={loadingBtnPdf}
                    icon={<DownloadOutlined />}
                    onClick={DownloadPdf}
                  />
                </Tooltip>
              </div>
            ) : null}
            {btnReload && (
              <Tooltip title="Refresh">
                <Button onClick={onRefresh} className="flex px-2">
                  <ReloadOutlined />
                </Button>
              </Tooltip>
            )}
            {btnReload ? (
              <div>
                {/* <Tooltip title="Clear Filters">
                  <Button
                    type="primary"
                    ghost
                    icon={<MdFilterAltOff />}
                    onClick={onReload}
                  />
                </Tooltip> */}
                <Tooltip title="Clear Filters">
                  <Button onClick={onReload} className="flex px-2">
                    <MdFilterAltOff />
                  </Button>
                </Tooltip>
              </div>
            ) : null}
            {prefixTimeCalComponents}

            {btnAlertSettings ? (
              <Tooltip title="Go to alert rules">
                <Button
                  type="primary"
                  ghost
                  icon={<FiSettings />}
                  onClick={handleAction}
                />
              </Tooltip>
            ) : null}
          </div>
        </div>
        <Divider style={{ width: "110%", margin: "10px -30px" }} />
      </div>
    </>
  );
};

export default Filter;
